var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_20101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.19971 12.5C3.19971 12.5 6.39971 6.09998 11.9997 6.09998C17.5997 6.09998 20.7997 12.5 20.7997 12.5C20.7997 12.5 17.5997 18.9 11.9997 18.9C6.39971 18.9 3.19971 12.5 3.19971 12.5Z",
    stroke: "url(#paint0_linear_845_20101)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 14.9C13.3256 14.9 14.4001 13.8255 14.4001 12.5C14.4001 11.1745 13.3256 10.1 12.0001 10.1C10.6746 10.1 9.6001 11.1745 9.6001 12.5C9.6001 13.8255 10.6746 14.9 12.0001 14.9Z",
    stroke: "url(#paint1_linear_845_20101)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_845_20101",
    x1: 3.19971,
    y1: 6.09998,
    x2: 22.3243,
    y2: 9.06461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#883DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_845_20101",
    x1: 9.6001,
    y1: 10.1,
    x2: 14.8742,
    y2: 10.6946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#883DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B74AB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_20101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.3999 2.90002)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreview);
export default __webpack_public_path__ + "static/media/preview.1156aecc4dd51ae25828b6317ed72439.svg";
export { ForwardRef as ReactComponent };